import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { GetPurchaseBase } from './purchase-request.model';

@Injectable({
    providedIn: 'root'
})

export class PurchaseListService extends Subject<DataStateChangeEventArgs> {
    constructor(private http: HttpClient, public errorService: ErrorService) {
        super();
    }
    public execute(state: GetPurchaseBase): void {
        this.getPurchaseList(state).subscribe(x => super.next(x));
    }
    getPurchaseList(state?: GetPurchaseBase): Observable<DataStateChangeEventArgs> {
        return this.http.post<any>("api/PurchaseRequest/GetPurchaseRequests?", state)
            .pipe(map(
                (response: any) =>
                    <any>{
                        result: response['result'],
                        count: response['count']
                    }
            ))
    }
}

